import script from "./SurveyRequiredPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyRequiredPrompt.vue?vue&type=script&setup=true&lang=ts"

import "./SurveyRequiredPrompt.vue?vue&type=style&index=0&id=20f5baa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f5baa5"]])

export default __exports__